export const createPropPicker =
    <O extends Record<string, string>, R extends unknown = string>(
        map: Record<O[keyof O], R>,
        defaultValue = '' as R,
    ) =>
    (key: O[keyof O]) =>
        map[key] || defaultValue

/**
 *
 * @param 상수맵을 전달하면 key, value 위치가 뒤바뀐 readonly 객체를 리턴하는 유틸
 */
export const createReverseMap = <T extends Record<string, string>>(record: T): Record<T[keyof T], keyof T> => {
    return Object.entries(record).reduce(
        (acc, [key, value]) => ({
            ...acc,
            [value as T[keyof T]]: key,
        }),
        {} as {readonly [P in T[keyof T]]: keyof T},
    )
}
